import { ModelScreenshot } from 'src/generated/graphql';
import { LightboxImage } from 'src/machines/lightboxMachine';

// TODO: format the screenshots on the server, in a new query.
// Generate an array with all the images from screenshots + renderings
export default (screenshots: ModelScreenshot[], eventId: string) => {
  let startingIndex = 0;

  const imageData = screenshots.reduce(
    (result: LightboxImage[], screenshot: ModelScreenshot) => {
      const { rendering } = screenshot;

      // add screenshot image
      result.push({
        id: screenshot.id,
        screenshotId: screenshot.id,
        enhanced: false,
        imgUrl: screenshot.placeholderUrl,
      });

      if (eventId === screenshot.id) {
        startingIndex = result.length - 1;
      }

      // add rendering image if complete
      if (rendering.state === 'completed') {
        result.push({
          id: rendering.id,
          screenshotId: screenshot.id,
          enhanced: true,
          imgUrl: rendering.versionUrls!.large!,
        });

        if (eventId === rendering.id) {
          startingIndex = result.length - 1;
        }
      }

      return result;
    },
    [],
  );

  return {
    index: startingIndex,
    imageData,
  };
};
